import { render, staticRenderFns } from "./EvaluacionRespetoPrincipiosValoresDialogComponent.vue?vue&type=template&id=edaf86d8"
import script from "./EvaluacionRespetoPrincipiosValoresDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionRespetoPrincipiosValoresDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports